// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3ayQK","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1DzY4"};